import CovalLogo from "@/components/icons/CovalLogo"

const navLinks = [
  {
    name: "Home",
    href: "#",
  },
  {
    name: "About Us",
    href: "https://www.coval.dev/about-us",
  },
  {
    name: "Book a Demo",
    href: "https://cal.com/bnhopkins/demo",
  },
]

export default function Footer() {
  return (
    <footer className="w-full mt-auto">
      <div className="w-full px-6 py-6 lg:px-8">
        <div className="flex items-center gap-3 mb-2">
          <div className="flex items-center">
            <CovalLogo theme="light" />
            <div className="w-2" aria-hidden />
            <span className="text-medium font-medium">COVAL</span>
          </div>
          <div className="h-4 w-px bg-coval-border" aria-hidden />
          <div className="flex flex-wrap gap-x-4 gap-y-1">
            {navLinks.map((item) => (
              <a
                key={item.name}
                className="text-coval-text-muted"
                href={item.href}
                target={item.href.startsWith("http") ? "_blank" : undefined}
                rel={
                  item.href.startsWith("http")
                    ? "noopener noreferrer"
                    : undefined
                }
              >
                {item.name}
              </a>
            ))}
          </div>
        </div>
        <p className="text-start text-small text-coval-text-muted">
          &copy; 2026 Coval Dev. All rights reserved.
        </p>
      </div>
    </footer>
  )
}
